import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/Insurance.css";
import PolicyRenewalModal from "../components/PolicyRenewalModal";

const Insurance = () => {
  const navigate = useNavigate();
  const [showRenewalForm, setShowRenewalForm] = useState(false);


  return (
    <div className="insurance-page">
      <button className="back-button" onClick={() => navigate("/services")}>
        ← Back to Services
      </button>

      <div className="header-container">
        <h2>📇 Insurance Services</h2>
      </div>

      <div className="info-row">
        {/* LEFT SIDE */}
        <div className="left-column">
          <div className="section-container">
            <p>
              RCS is a sub office of Apex Insurance Brokers,
              Headed in Georgetown Guyana,
              We assist in renewing current policies and most reliably, we effect new policies for motor, fire, life and general <strong>AT ALL INSURANCE COMPANIES IN GUYANA</strong>
            </p>
          </div>

          <div className="section-container">
            <p>
              RCS makes it easy for vehicle and homeowners, where we effectively renew existing policies
              and even effect new policies, with any insurance company tailored to meet our client needs.
            </p>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="right-column">
          <div className="info-box">
            <h4>📢 DID YOU KNOW?</h4>
            <p>
              RCS also handles policy submissions to insurers and ensures clients are reminded
              ahead of renewal deadlines. Avoid lapses by letting us manage your schedule. As your appointed broker,
              RCS renews your policies ahead before they laspse, saving you extra costs and time!
            </p>
          </div>

          <div className="info-box">
            <h4>Have a Policy to renew?</h4>
            <p>
No worries, enjoy hastle free renewal by following the link below:
            </p>
            <button className="renewal-button" onClick={() => setShowRenewalForm(true)}>
  Renew a Policy
</button>

          </div>
        </div>
      </div>
      {showRenewalForm && (
  <PolicyRenewalModal onClose={() => setShowRenewalForm(false)} />
)}

    </div>
  );
};

export default Insurance;
